<template>
  <el-container class="app-container">
    <!-- 顶部导航栏 -->
    <el-header class="app-header">
      <div class="header-content">
        <div class="logo">
          <el-icon :size="24" color="#409eff"><Picture /></el-icon>
          <span class="logo-text">验证码识别系统</span>
        </div>
        <el-menu
          :default-active="activeIndex"
          class="header-menu"
          mode="horizontal"
          :router="true"
          @select="handleMenuSelect"
        >
          <el-menu-item index="/dashboard">
            <el-icon><DataBoard /></el-icon>
            <span>系统概览</span>
          </el-menu-item>
          <el-menu-item index="/recognition">
            <el-icon><Camera /></el-icon>
            <span>在线识别</span>
          </el-menu-item>
          <el-menu-item index="/history">
            <el-icon><Clock /></el-icon>
            <span>识别历史</span>
          </el-menu-item>
          <el-menu-item index="/model-history">
            <el-icon><Histogram /></el-icon>
            <span>模型历史</span>
          </el-menu-item>
          <el-menu-item index="/model-tester">
            <el-icon><Monitor /></el-icon>
            <span>模型评测</span>
          </el-menu-item>
        </el-menu>
      </div>
    </el-header>

    <!-- 主内容区域 -->
    <el-main class="app-main">
      <router-view />
    </el-main>

    <!-- 底部 -->
    <el-footer class="app-footer">
      <div class="footer-content">
        <p>验证码识别系统 © 2025 | 基于 Vue 3 + Spring Boot + 自训练的验证码识别模型</p>
      </div>
    </el-footer>
  </el-container>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import {Picture, DataBoard, Camera, Clock, Histogram, Monitor} from '@element-plus/icons-vue'

const route = useRoute()
const activeIndex = ref('/dashboard')

// 监听路由变化，更新激活菜单
watch(
  () => route.path,
  (newPath) => {
    activeIndex.value = newPath
  },
  { immediate: true }
)

const handleMenuSelect = (index) => {
  activeIndex.value = index
}
</script>

<style scoped>
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-header {
  background: #ffffff;
  border-bottom: 1px solid #e4e7ed;
  padding: 0;
  height: 64px !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.logo-text {
  background: linear-gradient(135deg, #409eff 0%, #67c23a 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.header-menu {
  border-bottom: none;
  flex: 1;
  justify-content: flex-end;
}

.header-menu .el-menu-item {
  height: 64px;
  line-height: 64px;
  border-bottom: none;
}

.header-menu .el-menu-item:hover {
  background-color: #ecf5ff;
}

.header-menu .el-menu-item.is-active {
  border-bottom: 2px solid #409eff;
  color: #409eff;
}

.app-main {
  flex: 1;
  background: #f5f7fa;
  padding: 0;
  overflow-x: hidden;
}

.app-footer {
  background: #ffffff;
  border-top: 1px solid #e4e7ed;
  height: 40px !important;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-content {
  text-align: center;
  color: #909399;
  font-size: 14px;
}

.footer-content p {
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    height: auto;
    padding: 10px;
  }

  .logo {
    margin-bottom: 10px;
  }

  .header-menu {
    width: 100%;
  }

  .header-menu .el-menu-item {
    height: 50px;
    line-height: 50px;
    padding: 0 10px;
  }
}
</style>

<style>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  width: 100%;
  min-height: 100vh;
}
</style>